import './RulesModal.css';
import RulesModal from './RulesModal';
export default RulesModal;



// WEBPACK FOOTER //
// ./src/components/Game/components/GameInfo/components/RulesModal/index.js